import React from "react";
import { Typography, Box, styled, SxProps } from "@mui/material";

export const GaugeChartContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    alignItems: "flex-start",
  },
}));

export const LabelRow = ({
  label,
  value,
  sx,
}: {
  label: string;
  value: string | number;
  sx?: SxProps;
}) => {
  return (
    <Box display="flex" alignItems="center" gap={2} sx={sx}>
      <Typography variant="body3" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body3" color="text.primary">
        {value}
      </Typography>
    </Box>
  );
};
